module.exports = __webpack_public_path__ + "static/img/side.1003ef87.jpg";